<template>
  <div>
    <el-dialog
      :title="title"
      :show-close="false"
      center
      append-to-body
      width="25%"
      :close-on-click-modal="false"
      :visible.sync="dialogTableVisible"
    >
      <div class="fk_title" v-html="content"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close('1')" size="small">关 闭</el-button>
        <el-button class="btnSub" size="small" @click="close('2')">关闭并不再提示</el-button>
        <el-button v-if="url" @click="seeUrl" class="btnSub" size="small">了解详情</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { parseTime } from '@/utils/validate';
export default {
  name: 'notice',
  props: {
    title: {
      type: String,
      default: '通知公告'
    }
  },
  data() {
    return {
      dialogTableVisible: false,
      content: '',
      key: '',
      url: ''
    };
  },
  mounted() {},
  methods: {
    _open(content, key, start, end, url) {
      const _date = parseTime(new Date(), '{y}-{m}-{d} {h}:{i}');
      this.key = key || 'isClose';
      const _keyVal = this.getKey(); //取出key值
      console.log(_keyVal);
      if (_date > start && _date < end && (!_keyVal || _keyVal !== '2')) {
        this.content = content;
        this.url = url;
        this.dialogTableVisible = true;
      }
    },
    // 1、关闭  2、关闭并不再提示
    close(type) {
      this.dialogTableVisible = false;
      if (type == '1') {
        this.setKey(type, 2);
      } else {
        localStorage.setItem(this.key, type);
      }
    },
    seeUrl() {
      window.open(this.url);
    },
    //设置key过期时长  1小时
    setKey(val, time = 1) {
      var item = {
        value: val,
        expire: new Date().getTime() + 1000 * 60 * 60 * time // 过期时间为当前时间 + time小时
      };
      localStorage.setItem(this.key, JSON.stringify(item));
    },
    //获取key，判断是否过期
    getKey() {
      var item = JSON.parse(localStorage.getItem(this.key));
      if (!item) return null;
      if (item.expire) {
        //设置了过期时间
        if (item && item.expire > new Date().getTime()) {
          var message = item.value;
          return message;
        } else {
          localStorage.removeItem(this.key);
        }
      } else {
        return localStorage.getItem(this.key);
      }
    }
  }
};
</script>

<style scoped>
.fk_title {
  line-height: 20px;
  letter-spacing: 2px;
  font-size: 16px;
}

::v-deep .el-dialog__body {
  padding: 15px 25px 20px;
}
</style>
